import List from "./list/list.module";
import Count from "./count/count.store";

export default {
  modules: { List, Count },
};
